import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=067a5dad&"
import script from "./ImageInput.vue?vue&type=script&lang=js&"
export * from "./ImageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports